import { Component } from "@angular/core";

@Component({
  selector: "oz-best-practices",
  templateUrl: "./best-practices.component.pug",
})
export class BestPracticesComponent {
  constructor() {}
}
